import { createAction, props } from '@ngrx/store';
import {
  IApproveBankProofRequest,
  IApproveBankProofResponse,
  IBankProof,
  IRejectBankProofRequest,
  IRejectBankProofResponse
} from '../models/bank-proof.model';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';

// CURRENT
export const loadBankProofs = createAction('[BankProofs] Load BankProofs', props<{ customerId: string; withdrawalId: string }>());

export const loadBankProofsSuccess = createAction('[BankProofs] Load BankProofs Success', props<{ response: IBankProof }>());

export const loadBankProofsFailure = createAction('[BankProofs] Load BankProofs Failure', props<{ error: IGenericError<ErrorResponse> }>());

//APPROVE BankProof
export const approveBankProofRequest = createAction(
  '[ApproveBankProof] Load ApproveBankProof',
  props<{ request: IApproveBankProofRequest }>()
);

export const approveBankProofResponse = createAction(
  '[ApproveBankProof] Load ApproveBankProof Success',
  props<{ response: IApproveBankProofResponse }>()
);

export const approveBankProofFailure = createAction(
  '[ApproveBankProof] Load BankProof Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//REJECT BankProof
export const rejectBankProofRequest = createAction('[BankProof] Load reject BankProof', props<{ request: IRejectBankProofRequest }>());

export const rejectBankProofResponse = createAction(
  '[BankProof] Load reject BankProof Success',
  props<{ response: IRejectBankProofResponse }>()
);

export const rejectBankProofFailure = createAction(
  '[BankProof] Load reject BankProof Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
